import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import CompanyIntroPage from './pages/CompanyIntroPage';
import ProductsPage from './pages/ProductsPage';
import OnlineRequestPage from './pages/OnlineRequestPage';
import DeliveryResultsPage from './pages/DeliveryResultsPage';
import './App.css';
import './pages/Page.css';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="company" element={<CompanyIntroPage />} />
        <Route path="products" element={<ProductsPage />} />
        <Route path="online-request" element={<OnlineRequestPage />} />
        <Route path="deliveries" element={<DeliveryResultsPage />} />
      </Route>
    </Routes>
  );
}

export default App;
